import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@material-ui/core/Grid';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import { faCogs } from '@fortawesome/free-solid-svg-icons';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import { faCloud } from '@fortawesome/free-solid-svg-icons';
import { faComments } from '@fortawesome/free-solid-svg-icons';

import bootstrap from '../static/img/bootstrap.svg';
import css from '../static/img/css.svg';
import html from '../static/img/html.svg';
import python from '../static/img/python.svg';
import django from '../static/img/django.svg';
import jquery from '../static/img/jquery.svg';
import javascript from '../static/img/js.svg';
import jupyternotebook from '../static/img/jupyter.svg';
import npm from '../static/img/npm.svg';
import nodejs from '../static/img/node.svg';
import git from '../static/img/git.svg';
import typescript from '../static/img/ts.svg';
import react from '../static/img/react.svg';
import aws from '../static/img/aws.svg';
import wordpress from '../static/img/wp.svg';
import firebase from '../static/img/firebase.svg';
import heroku from '../static/img/heroku.svg';
import vscode from '../static/img/vscode.svg';
import postgresql from '../static/img/postgresql.svg';
import redux from '../static/img/redux.svg';
import { useMediaQuery } from 'react-responsive';

const skillCardsEn = [
	{
		title: 'Web Application Development',
		img: faCode,
		content: 'Transform Ideas to reality with excellent user experience and design. Fast website with responsive layouts for any size device.'
	},
	{
		title: 'API Integration & Development',
		img: faCogs,
		content: 'A well-designed and documented REST API providing CRUD operations for your applications to consume.'
	},
	{
		title: 'Data Visualization',
		img: faChartLine,
		content: 'Create visually appealing diagrams and charts from databases and big data platforms.'
	},
	{
		title: 'Database Design',
		img: faDatabase,
		content:
			'Design and fine-tune the DB sufficiently to provide a flexible and stable high performance DB.'
	},
	{
		title: 'Cloud Integration',
		img: faCloud,
		content:
			'What kind of service should be used efficiently? Utilize my knowledge as a solution architect to build end-to-end solutions with cost/performance in mind.',
	},
	{
		title: 'Natural Language Processing',
		img: faComments,
		content: 'I also like the development of natural language processing fields for Japanese and English.'
	}
];

const skillCardsJa = [
	{
		title: 'ウェブアプリケーション開発',
		img: faCode,
		content: 'ユーザーが使いやすいデザインを大切にする考えのもと、アイデアを形にします。レスポンシブデザインの高速なウェブサイト'
	},
	{
		title: 'API導入と開発',
		img: faCogs,
		content: 'URI設計を十分行い、一貫性のあるREST API'
	},
	{
		title: 'データビジュアライズ化',
		img: faChartLine,
		content: 'データをどのように可視化したいかクライアントの要望を実現します。'
	},
	{
		title: 'DB設計',
		img: faDatabase,
		content:
			'DB設計を十分行い、柔軟で安定した高パフォーマンスDBを構築します。'
	},
	{
		title: 'クラウド',
		img: faCloud,
		content:
			'AWSが得意で、どのサービスを使うと効率的かソリューションアーキテクトとしての知見活かします。',
	},
	{
		title: '自然言語処理',
		img: faComments,
		content: '日本語と英語の自然言語処理分野の開発も好きです。'
	}
];

const mostUsedTechTitles = {en:'Most used technologies', ja:'よく使うもの'}
const mostUsedTechs = [
    {name:'Python',img:python},
    {name:'Javascript',img:javascript},
    {name:'TypeScript',img:typescript}, 
    {name:'HTML',img:html},
    {name:'CSS',img:css},
    {name:'Bootstrap',img:bootstrap},
    {name:'jQuery',img:jquery},
    {name:'NodeJs',img:nodejs},   
    {name:'npm',img:npm},
    {name:'React',img:react},
    {name:'Redux',img:redux},
    {name:'Django',img:django},
    {name:'WordPress',img:wordpress},
    {name:'AWS',img:aws},
    {name:'Firebase',img:firebase},
    {name:'Heroku',img:heroku},
    {name:'JupyterNotebook',img:jupyternotebook},
    {name:'Visual Studio Code',img:vscode},
    {name:'Git',img:git},
    {name:'postgresql',img:postgresql},
];


const App = ({language}) => {
	const [skillCards, setSkillCards] = useState([])
	useEffect(() => {
		language == 'English'? setSkillCards(skillCardsEn) : setSkillCards(skillCardsJa)
	}, [language])

	return (
		<div className="pt-3">
			<div className="mx-auto m-5 p-5">
				<Grid container spacing={5} className="w-70" >
					{skillCards.map((skill, i) => (
						<Grid item md={4} sm={6} key={i}  className="px-5">
							<div className="skillIconWrapper mb-3">
								<FontAwesomeIcon icon={skill.img} className="skillIcons" />
							</div>
							<h1 className="text-center mb-3">
								<strong>{skill.title}</strong>
							</h1>
							<p className="font-large">{skill.content}</p>
						</Grid>
					))}
				</Grid>
                <h1 className="text-center mb-3" style={{marginTop:'8rem'}}>
					<strong>{language=='English' ? mostUsedTechTitles.en : mostUsedTechTitles.ja}</strong>
							</h1>
				<div className="skillItems">
					{mostUsedTechs.map((tech, i) => (
						<span className="skillItem" key={i}>
                            <span><img src={tech.img}/></span>
							<span>{tech.name}</span>
						</span>
					))}
				</div>
			</div>
		</div>
	);
};
export default App;
